import type { HTMLAttributes, ReactNode } from "react";

import clsx from "clsx";

import styles from "./skeleton.module.css";

type SkeletonProps = HTMLAttributes<HTMLSpanElement> & {
	borderRadius?: number | string;
	height: number | string;
	width: number | string;
};

export function Skeleton({ borderRadius, height, width, ...props }: SkeletonProps): ReactNode {
	return (
		<span
			{...props}
			className={clsx(props.className, styles.skeleton)}
			data-testid="skeleton"
			style={{ ...props.style, borderRadius, height, width }}
		/>
	);
}
